import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'
import RouterTooltip from '../../../../components/RouterTooltip'
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  DragEndEvent,
} from '@dnd-kit/core'
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
  useSortable,
} from '@dnd-kit/sortable'
import {
  restrictToVerticalAxis,
  restrictToParentElement,
} from '@dnd-kit/modifiers'
import { CSS } from '@dnd-kit/utilities'
import save from '../../../../assets/router/save.svg'
import {
  Container,
  FormContainer,
  InputDiv,
  InputLabel,
  Input,
  StyledSelect,
  StyledOption,
  StyledDate,
  IframeContainer,
  ButtonOfSection,
  ButtonOfSectionText,
  OptionsDiv,
  StyledLink,
  StyledSearch,
  OptionsContainer,
  StyledFreightText,
  StyledFreight,
  StyledCheckList,
  FreightInfo,
  StyledFreightSubText,
  StyledFreightObsText,
  ContentContainer,
  StyledChecklistContainer,
  ContainerHeader,
  BigText,
  DivComponents,
  ButtonContainer,
  SwitchDiv,
  SwitchBox,
  SwitchInput,
  SwitchSlider,
  SelectData,
} from './style'
import SectionContext from '../../../../contexts/SectionContext'
import { Button } from 'react-bootstrap'
import { OptionSubText } from '../../../../components/AddStockModal/style'
import { mock } from './utils'
import { Freight as FreightType, RouterContext } from '../../../../contexts/RouterContext'
import axios from '../../../../config/axios'
import { id, ro } from 'date-fns/locale'
import { set } from 'date-fns'
import {
  GoogleMap,
  Marker,
  InfoWindow,
  useLoadScript,
  DirectionsRenderer,
  DirectionsService,
} from '@react-google-maps/api'
import MyMap from './map'
import { RouterInfoContext } from '../../../../contexts/RouterInfoContext'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { RouterOutletType } from '../index2'
import { ButtonCreate } from '../../../../components/styles/subheader-style'
import { FeedbackContext } from '../../../../contexts/FeedbackContext'
import {
  CenterItensContainer,
  ConformityStatus,
} from '../../../../components/routerModal/freightContent/freightForm/style'
import { Check, Info, Route, MapPin, MapPinOff, X } from 'lucide-react'
import view from '../../../../assets/global-assets/view.svg'

interface Waypoints {
  location: string
  stopover: boolean
}

interface FreightItem {
  id: number
  type?: string
  Company: {
    companyName: string
  }
  Address?: {
    street: string
    number: string
    Neighborhood?: {
      City?: {
        name: string
        State?: {
          uf: string
        }
      }
    }
  } | null
  routeId?: number | null
  observation?: string
  orderNumber?: string
}

export interface StopGroup {
  id: string
  address: string
  freights: FreightType[]
}

export const getAddressGroupKey = (freight: FreightType | FreightItem): string => {
  const addr = freight.Address
  if (!addr || !addr.street) return `single-${freight.id}`
  const street = (addr.street || '').trim().toLowerCase()
  const number = (addr.number || '').trim().toLowerCase()
  const neighborhood = (addr.Neighborhood as any)?.name
    ? (addr.Neighborhood as any).name.trim().toLowerCase()
    : ''
  const city = (addr.Neighborhood?.City?.name || '').trim().toLowerCase()
  const uf = (addr.Neighborhood?.City?.State?.uf || '').trim().toLowerCase()
  const cep = String((addr as any).cep || '').replace(/\D/g, '')
  return `${cep}_${street}_${number}_${neighborhood}_${city}_${uf}`
}

const getWaypointLetter = (
  index: number,
  hasCompanyOrigin: boolean = true,
): string => {
  const adjustedIndex = hasCompanyOrigin ? index + 1 : index
  if (adjustedIndex < 26) {
    return String.fromCharCode(65 + adjustedIndex)
  }
  const firstChar = String.fromCharCode(65 + Math.floor(adjustedIndex / 26) - 1)
  const secondChar = String.fromCharCode(65 + (adjustedIndex % 26))
  return `${firstChar}${secondChar}`
}

const MapPinBadge: React.FC<{ label: string }> = ({ label }) => {
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        width: '20px',
        height: '24px',
        flexShrink: 0,
      }}
      title={`Parada ${label} no mapa`}
    >
      <svg
        viewBox='0 0 24 30'
        width='20'
        height='24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M12 0C5.372 0 0 5.372 0 12c0 8.5 12 18 12 18s12-9.5 12-18c0-6.628-5.372-12-12-12z'
          fill='#EA4335'
        />
        <text
          x='12'
          y='12'
          fill='#FFFFFF'
          fontSize={label.length > 1 ? '9' : '11'}
          fontWeight='bold'
          textAnchor='middle'
          dominantBaseline='middle'
          fontFamily='Roboto, Arial, sans-serif'
        >
          {label}
        </text>
      </svg>
    </div>
  )
}

export const TypeBadge: React.FC<{ type?: string | null }> = ({ type }) => {
  const normalizedType = type?.toLowerCase() || ''
  const isPickup =
    normalizedType.includes('retirada') ||
    normalizedType.includes('coleta')
  const isWithoutAddress = normalizedType.includes('sem endereço')

  let color = '#0369a1'
  let backgroundColor = '#e0f2fe'

  if (isPickup) {
    color = '#b45309'
    backgroundColor = '#fef3c7'
  } else if (isWithoutAddress) {
    color = '#e11d48'
    backgroundColor = '#ffe4e6'
  }

  return (
    <span
      style={{
        fontSize: '11px',
        fontWeight: 600,
        color,
        backgroundColor,
        borderRadius: '4px',
        padding: '1px 6px',
        whiteSpace: 'nowrap',
        flexShrink: 0,
      }}
    >
      {type || 'Entrega'}
    </span>
  )
}

const NotDeliveredTag: React.FC = () => (
  <span
    style={{
      fontSize: '11px',
      fontWeight: 600,
      color: '#c62828',
      backgroundColor: 'rgba(245, 142, 142, 0.3)',
      borderRadius: '4px',
      padding: '1px 6px',
      whiteSpace: 'nowrap',
      flexShrink: 0,
    }}
  >
    Não Entregue
  </span>
)

const DraggableStopGroupItem: React.FC<{
  group: StopGroup
  index: number
  hasCompanyOrigin: boolean
  onUnselectFreight: (id: number) => void
}> = ({ group, index, hasCompanyOrigin, onUnselectFreight }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: group.id,
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  }

  const hasAddress = Boolean(group.address && group.address !== 'Sem endereço')
  const letter = getWaypointLetter(index, hasCompanyOrigin)

  if (group.freights.length === 1) {
    const freight = group.freights[0]
    const freightHasAddress = Boolean(freight.Address?.street)
    return (
      <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
        <StyledFreight
          style={{
            cursor: 'grab',
            border: isDragging
              ? '2px dashed #3b82f6'
              : !freightHasAddress
              ? '1px solid #fecdd3'
              : undefined,
            borderLeft: !freightHasAddress ? '4px solid #f43f5e' : undefined,
            backgroundColor: isDragging ? '#f3f4f6' : undefined,
          }}
        >
          <StyledChecklistContainer
            onClick={(e) => {
              e.stopPropagation()
              onUnselectFreight(freight.id)
            }}
          >
            <StyledCheckList className='selected' />
          </StyledChecklistContainer>
          <FreightInfo>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                flexWrap: 'wrap',
              }}
            >
              <StyledFreightText title={freight.Company.companyName}>
                {freight.Company.companyName.split(' ').slice(0, 2).join(' ')}
              </StyledFreightText>
              <TypeBadge type={freight.type} />
              {freight.status === 'Não Entregue' && <NotDeliveredTag />}
            </div>
            <div>
              {freightHasAddress ? (
                <StyledFreightSubText>
                  {`${freight.Address?.street || ''}, ${freight.Address?.number || ''} - ${freight.Address?.Neighborhood?.City?.name || ''}/${freight.Address?.Neighborhood?.City?.State?.uf || ''}`}
                </StyledFreightSubText>
              ) : (
                <StyledFreightSubText
                  style={{
                    color: '#e11d48',
                    fontStyle: 'italic',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    marginTop: '2px',
                  }}
                >
                  <MapPinOff size={11} />
                  Sem endereço cadastrado
                </StyledFreightSubText>
              )}
              {freight.observation && (
                <StyledFreightObsText title={freight.observation}>
                  Obs: {freight.observation}
                </StyledFreightObsText>
              )}
            </div>
          </FreightInfo>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              flexShrink: 0,
            }}
          >
            {freightHasAddress ? (
              <MapPinBadge label={letter} />
            ) : (
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '2px 5px',
                  borderRadius: '4px',
                  backgroundColor: '#fee2e2',
                  color: '#e11d48',
                  fontSize: '10px',
                  fontWeight: 600,
                  whiteSpace: 'nowrap',
                }}
                title='Sem endereço no mapa'
              >
                Sem ponto
              </span>
            )}
            <RouterTooltip key={`draggable-${freight.id}`} freight={freight}>
              <img src={view} alt='view-icon' />
            </RouterTooltip>
          </div>
        </StyledFreight>
      </div>
    )
  }

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <div
        style={{
          width: '100%',
          borderRadius: '0.3rem',
          backgroundColor: '#fff',
          marginTop: '0.5rem',
          padding: '0.5rem',
          cursor: 'grab',
          border: isDragging ? '2px dashed #3b82f6' : '1px solid #e5e7eb',
          boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingBottom: '6px',
            borderBottom: '1px solid #f3f4f6',
            marginBottom: '6px',
            gap: '6px',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              minWidth: 0,
            }}
          >
            {hasAddress && <MapPinBadge label={letter} />}
            <div style={{ minWidth: 0 }}>
              <div
                style={{
                  fontSize: '11px',
                  fontWeight: 600,
                  color: '#4b5563',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
                title={group.address}
              >
                {group.address}
              </div>
            </div>
          </div>
          <span
            style={{
              fontSize: '10px',
              fontWeight: 600,
              backgroundColor: '#f0fdf4',
              color: '#166534',
              borderRadius: '4px',
              padding: '2px 6px',
              whiteSpace: 'nowrap',
              flexShrink: 0,
            }}
          >
            {group.freights.length} fretes no local
          </span>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
          {group.freights.map((freight) => (
            <div
              key={freight.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                backgroundColor: '#f9fafb',
                borderRadius: '4px',
                padding: '4px 6px',
                gap: '6px',
              }}
            >
              <div
                style={{ cursor: 'pointer', flexShrink: 0 }}
                onClick={(e) => {
                  e.stopPropagation()
                  onUnselectFreight(freight.id)
                }}
                title='Remover este frete da rota'
              >
                <StyledCheckList className='selected' />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    flexWrap: 'wrap',
                  }}
                >
                  <span
                    style={{
                      fontSize: '12px',
                      fontWeight: 600,
                      color: '#1f2937',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      maxWidth: '130px',
                    }}
                    title={freight.Company?.companyName}
                  >
                    {freight.Company?.companyName}
                  </span>
                  <TypeBadge type={freight.type} />
                  {freight.status === 'Não Entregue' && <NotDeliveredTag />}
                </div>
                {freight.orderNumber && (
                  <div style={{ fontSize: '11px', color: '#6b7280' }}>
                    Venda: {freight.orderNumber}
                  </div>
                )}
                {freight.observation && (
                  <div
                    style={{
                      fontSize: '10px',
                      color: '#9ca3af',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                    title={freight.observation}
                  >
                    Obs: {freight.observation}
                  </div>
                )}
              </div>
              <div style={{ flexShrink: 0 }}>
                <RouterTooltip
                  key={`draggable-${freight.id}`}
                  freight={freight}
                >
                  <img src={view} alt='view-icon' />
                </RouterTooltip>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

const NewRouter = () => {
  // Date formatting functions
  const formatToDateInput = (dateString: string): string => {
    if (!dateString || dateString.length < 10) return ''
    const [day, month, year] = dateString.split('/')
    return `${year}-${month}-${day}`
  }

  const formatFromDateInput = (dateString: string): string => {
    if (!dateString || dateString.length < 10) return ''

    const dateRegex = /^\d{4}-\d{2}-\d{2}$/
    if (!dateRegex.test(dateString)) return ''

    const [year, month, day] = dateString.split('-')

    if (year.length !== 4) return ''

    return `${day}/${month}/${year}`
  }

  const dataFormatter = (isoDateString: string): string => {
    if (!isoDateString) {
      return '' // Retorna vazio se a string for nula ou vazia
    }

    const dateUtc = new Date(isoDateString)

    // Verifica se a data é válida antes de tentar formatar
    if (isNaN(dateUtc.getTime())) {
      console.error('Data ISO inválida recebida:', isoDateString)
      return '' // Trata o caso de uma string de data inválida
    }

    // Extrai as partes da data diretamente do UTC
    const year = dateUtc.getUTCFullYear()
    const month = dateUtc.getUTCMonth() + 1 // getUTCMonth é 0-indexado, então adiciona 1
    const day = dateUtc.getUTCDate()

    // Garante que mês e dia tenham dois dígitos (ex: 01 em vez de 1)
    const formattedMonth = month < 10 ? `0${month}` : month
    const formattedDay = day < 10 ? `0${day}` : day

    return `${formattedDay}/${formattedMonth}/${year}`
  }

  const dataFormatterISO = (dateString: string): string => {
    // Verifica se a string de data está no formato esperado (dd/mm/yyyy)
    const parts = dateString.split('/')
    if (parts.length !== 3) {
      console.error(
        "Formato de data inválido. Esperado 'dd/mm/yyyy'. Recebido:",
        dateString,
      )
      // Ou você pode lançar um erro: throw new Error("Formato de data inválido.");
      return '' // Retorna uma string vazia ou trata o erro como preferir
    }

    const [day, month, year] = parts

    // Constrói um objeto Date em UTC para evitar problemas de fuso horário local
    // Lembre-se que o mês no construtor de Date é 0-indexado (Janeiro = 0, Fevereiro = 1, etc.)
    const dateObject = new Date(
      Date.UTC(parseInt(year), parseInt(month) - 1, parseInt(day)),
    )

    // Opcional: Validação para datas inválidas (ex: "30/02/2025")
    // Se a data fornecida for inválida, Date.UTC() ainda pode criar um objeto Date,
    // mas com o dia "corrigido" (ex: 30/02 vira 02/03).
    // Esta verificação garante que a data original era logicamente válida.
    if (
      dateObject.getUTCFullYear() !== parseInt(year) ||
      dateObject.getUTCMonth() !== parseInt(month) - 1 ||
      dateObject.getUTCDate() !== parseInt(day)
    ) {
      console.error("A data original ('" + dateString + "') é inválida.")
      return '' // Retorna string vazia ou trata o erro
    }

    // Converte o objeto Date para a string ISO 8601 (ex: "2025-02-28T00:00:00.000Z")
    return dateObject.toISOString()
  }

  const { setFeedback } = useContext(FeedbackContext)
  const { setTabIndex } = useOutletContext<RouterOutletType>()
  const navigate = useNavigate()
  const { routerSection, setRouterSection } = useContext(SectionContext)
  const [test, setTest] = useState(false)
  const { router, setRouter } = useContext(RouterContext)
  const [freightSelected, setFreightSelected] = useState<number[]>([])
  const [orderedFreights, setOrderedFreights] = useState<FreightType[]>([])
  const [addressFreight, setAddressFreight] = useState<string[]>([])
  const [freights, setFreights] = useState<FreightType[]>([])
  const [url, setUrl] = useState(
    'https://www.google.com.br/maps?q=06278-010,%20Brasil&output=embed',
  )
  const [date, setDate] = useState(dataFormatter(router?.date || ''))
  const [selectedVehicle, setSelectedVehicle] = useState<number>(
    router?.Vehicle?.id || 0,
  )
  const [vehicles, setVehicles] = useState<any[]>([])
  const [companyDestination, setCompanyDestination] = useState<boolean>(
    router?.companyDestination || true,
  )
  const [duplicateBlocker, setDuplicateBlocker] = useState<boolean>(false)
  const [responsible, setresponsible] = useState<string>(
    router?.responsible || '',
  )

  const initialWaypoints = useMemo(() => {
    return []
  }, [])
  const [waypoints, setWayPoints] = useState<Waypoints[]>(initialWaypoints)
  const { routerInfo, setRouterInfo } = useContext(RouterInfoContext)

  // Drag and drop sensors
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  )

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value

    if (value.length > 10) {
      e.target.value = value.slice(0, 10)
      return
    }

    if (value.length === 10) {
      const year = value.split('-')[0]
      if (year.length > 4) {
        e.target.value = value.slice(0, 6) + value.slice(7)
        return
      }
    }

    setDate(formatFromDateInput(value))
  }

  // Handle drag end for reordering
  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event

    if (!over || active.id === over.id) {
      return
    }

    const activeIndex = orderedStopGroups.findIndex(
      (group) => group.id === active.id,
    )
    const overIndex = orderedStopGroups.findIndex(
      (group) => group.id === over.id,
    )

    if (activeIndex !== -1 && overIndex !== -1) {
      const newOrderedGroups = arrayMove(
        orderedStopGroups,
        activeIndex,
        overIndex,
      )
      const newOrderedFreights = newOrderedGroups.flatMap(
        (group) => group.freights,
      )
      setOrderedFreights(newOrderedFreights)

      const newWaypoints = newOrderedFreights
        .filter((freight) => freight.Address?.street)
        .map((freight) => ({
          location: `${freight.Address!.street}, ${freight.Address!.number} - ${freight.Address!.Neighborhood?.City?.name || ''}/${freight.Address!.Neighborhood?.City?.State?.uf || ''}`,
          stopover: true,
        }))
      setWayPoints(newWaypoints)
    }
  }

  const postRouter = async () => {
    setDuplicateBlocker(true)
    try {
      const body = {
        date: dataFormatterISO(date),
        status: 'A programar',
        freightIds: orderedFreights.map((freight) => freight.id),
        track: routerInfo?.track,
        companyDestination: companyDestination,
        url:
          routerInfo?.url ||
          'https://www.google.com.br/maps?q=06278-010,%20Brasil&output=embed',
        origin: router?.origin || 'vendas',
        vehicleId: Number(selectedVehicle),
        responsible: responsible,
      }

      const response = await axios.post(
        `${process.env.REACT_APP_GATEWAY_BASE_URL}/router/route`,
        body,
      )
      setFeedback({
        isOpen: true,
        message: 'Rota criada com sucesso!',
        statusOk: true,
      })
      setDuplicateBlocker(false)
      setRouterSection('routers')
      navigate('/panel/router/routers')
    } catch {
      setFeedback({
        isOpen: true,
        message: 'Erro ao criar rota!',
        statusOk: false,
      })
      setDuplicateBlocker(false)
    }
  }

  const putRouter = async () => {
    setDuplicateBlocker(true)
    try {
      const body = {
        id: router?.id,
        date: dataFormatterISO(date),
        status: 'A programar',
        freightIds: orderedFreights.map((freight) => freight.id),
        companyDestination: companyDestination,
        track: routerInfo?.track,
        url: routerInfo?.url,
        origin: router?.origin || 'vendas',
        vehicleId: Number(selectedVehicle),
        responsible: responsible,
      }
      const response = await axios.put(
        `${process.env.REACT_APP_GATEWAY_BASE_URL}/router/route`,
        body,
      )
      setRouter(null)
      setRouterSection('routers')
      navigate('/panel/router/routers')
      setFeedback({
        isOpen: true,
        message: 'Rota atualizada com sucesso!',
        statusOk: true,
      })
      setDuplicateBlocker(false)
    } catch {
      setFeedback({
        isOpen: true,
        message: 'Erro ao atualizar rota!',
        statusOk: false,
      })
      setDuplicateBlocker(false)
    }
  }

  const [originAddress, setOriginAddress] = useState<string>('')
  const [companyCoordinates, setCompanyCoordinates] = useState<{
    lat: number
    lng: number
  } | null>(null)
  const [isOptimizing, setIsOptimizing] = useState<boolean>(false)

  useEffect(() => {
    const fetchCompanyAddress = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_GATEWAY_BASE_URL}/companies/companies/me/details`,
        )
        const data = response.data
        const street = data.street || data.Address?.street || ''
        const number = data.number || data.Address?.number || ''
        const neighborhood =
          data.neighborhood?.name ||
          data.neighborhood ||
          data.Address?.Neighborhood?.name ||
          ''
        const city =
          data.city?.name || data.Address?.Neighborhood?.City?.name || ''
        const state =
          data.city?.state?.uf ||
          data.state?.name ||
          data.Address?.Neighborhood?.City?.State?.uf ||
          ''
        const cep = data.cep || data.Address?.cep || ''

        if (data.latitude && data.longitude) {
          setCompanyCoordinates({
            lat: Number(data.latitude),
            lng: Number(data.longitude),
          })
        } else if (data.Address?.latitude && data.Address?.longitude) {
          setCompanyCoordinates({
            lat: Number(data.Address.latitude),
            lng: Number(data.Address.longitude),
          })
        }

        const addressParts: string[] = []
        if (street) addressParts.push(number ? `${street}, ${number}` : street)
        if (neighborhood) addressParts.push(neighborhood)
        if (city && state) addressParts.push(`${city} - ${state}`)
        else if (city) addressParts.push(city)
        if (cep) addressParts.push(cep)
        addressParts.push('Brasil')

        const fullAddress = addressParts.length > 1 ? addressParts.join(', ') : ''
        setOriginAddress(fullAddress)
      } catch (error: any) {
        console.error('Erro ao carregar endereço da empresa:', error)
      }
    }
    fetchCompanyAddress()
  }, [])

  useEffect(() => {
    if (!originAddress || companyCoordinates) return
    const googleMaps = (window as any).google?.maps
    if (googleMaps?.Geocoder) {
      const geocoder = new googleMaps.Geocoder()
      geocoder.geocode({ address: originAddress }, (results: any, status: any) => {
        if (status === 'OK' && results?.[0]?.geometry?.location) {
          setCompanyCoordinates({
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng(),
          })
        }
      })
    }
  }, [originAddress, companyCoordinates])

  const [sameAddressModal, setSameAddressModal] = useState<{
    isOpen: boolean
    targetFreight: FreightType | null
    matchingFreights: FreightType[]
  }>({
    isOpen: false,
    targetFreight: null,
    matchingFreights: [],
  })

  const [searchTerm, setSearchTerm] = useState<string>('')

  const normalizeText = (text: string) =>
    (text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')

  const availableFreights = useMemo(() => {
    return freights.filter((f) => {
      if (freightSelected.includes(f.id)) return false
      const status = (f.status || '').trim().toLowerCase()
      if (
        status === 'entregue' ||
        status === 'coletado' ||
        status === 'concluído' ||
        status === 'concluido' ||
        status === 'indefinido' ||
        status === 'cancelado' ||
        status === 'endereço pendente' ||
        status === 'endereco pendente'
      ) {
        return false
      }
      return true
    })
  }, [freights, freightSelected])

  const orderedStopGroups = useMemo(() => {
    const groupsMap = new Map<string, StopGroup>()
    orderedFreights.forEach((f) => {
      const key = getAddressGroupKey(f)
      if (!groupsMap.has(key)) {
        const addr = f.Address
        const addrStr = addr
          ? `${addr.street}, ${addr.number} - ${addr.Neighborhood?.City?.name || ''}/${addr.Neighborhood?.City?.State?.uf || ''}`
          : 'Sem endereço'
        groupsMap.set(key, {
          id: key,
          address: addrStr,
          freights: [],
        })
      }
      groupsMap.get(key)!.freights.push(f)
    })
    return Array.from(groupsMap.values())
  }, [orderedFreights])

  const filteredOrderedStopGroups = useMemo(() => {
    if (!searchTerm.trim()) return orderedStopGroups
    const term = normalizeText(searchTerm)
    return orderedStopGroups.filter((group) => {
      const matchAddress = normalizeText(group.address).includes(term)
      const matchFreight = group.freights.some((f) => {
        const company = normalizeText(f.Company?.companyName || '')
        const obs = normalizeText(f.observation || '')
        const order = normalizeText(f.orderNumber || '')
        const type = normalizeText(f.type || '')
        return (
          company.includes(term) ||
          obs.includes(term) ||
          order.includes(term) ||
          type.includes(term)
        )
      })
      return matchAddress || matchFreight
    })
  }, [orderedStopGroups, searchTerm])

  const filteredAvailableFreights = useMemo(() => {
    if (!searchTerm.trim()) return availableFreights
    const term = normalizeText(searchTerm)
    return availableFreights.filter((f) => {
      const company = normalizeText(f.Company?.companyName || '')
      const street = normalizeText(f.Address?.street || '')
      const number = normalizeText(f.Address?.number || '')
      const neighborhood = normalizeText(f.Address?.Neighborhood?.name || '')
      const city = normalizeText(f.Address?.Neighborhood?.City?.name || '')
      const state = normalizeText(
        f.Address?.Neighborhood?.City?.State?.uf || '',
      )
      const obs = normalizeText(f.observation || '')
      const order = normalizeText(f.orderNumber || '')
      const type = normalizeText(f.type || '')
      return (
        company.includes(term) ||
        street.includes(term) ||
        number.includes(term) ||
        neighborhood.includes(term) ||
        city.includes(term) ||
        state.includes(term) ||
        obs.includes(term) ||
        order.includes(term) ||
        type.includes(term)
      )
    })
  }, [availableFreights, searchTerm])

  const availableWithAddress = useMemo(() => {
    return filteredAvailableFreights.filter(
      (f) =>
        Boolean(f.Address?.street) &&
        !f.type?.toLowerCase().includes('sem endereço'),
    )
  }, [filteredAvailableFreights])

  const availableWithoutAddress = useMemo(() => {
    return filteredAvailableFreights.filter(
      (f) =>
        !f.Address?.street ||
        Boolean(f.type?.toLowerCase().includes('sem endereço')),
    )
  }, [filteredAvailableFreights])

  const addFreightsToSelection = (freightsToAdd: FreightType[]) => {
    const newIds = freightsToAdd.map((f) => f.id)
    const nextSelected = [...freightSelected, ...newIds]
    const nextOrdered = [...orderedFreights, ...freightsToAdd]
    setFreightSelected(nextSelected)
    setOrderedFreights(nextOrdered)

    const updatedGroups = new Map<string, string>()
    nextOrdered.forEach((f) => {
      if (!f.Address?.street) return
      const key = getAddressGroupKey(f)
      if (!updatedGroups.has(key)) {
        const addr = f.Address
        updatedGroups.set(
          key,
          `${addr.street}, ${addr.number} - ${addr.Neighborhood?.City?.name || ''}/${addr.Neighborhood?.City?.State?.uf || ''}`,
        )
      }
    })
    setWayPoints(
      Array.from(updatedGroups.values()).map((location) => ({
        location,
        stopover: true,
      })),
    )
  }

  const handleUnselectFreight = (id: number) => {
    const nextSelected = freightSelected.filter((freightId) => freightId !== id)
    const nextOrdered = orderedFreights.filter((item) => item.id !== id)
    setFreightSelected(nextSelected)
    setOrderedFreights(nextOrdered)

    const updatedGroups = new Map<string, string>()
    nextOrdered.forEach((f) => {
      if (!f.Address?.street) return
      const key = getAddressGroupKey(f)
      if (!updatedGroups.has(key)) {
        const addr = f.Address
        updatedGroups.set(
          key,
          `${addr.street}, ${addr.number} - ${addr.Neighborhood?.City?.name || ''}/${addr.Neighborhood?.City?.State?.uf || ''}`,
        )
      }
    })
    setWayPoints(
      Array.from(updatedGroups.values()).map((location) => ({
        location,
        stopover: true,
      })),
    )
  }

  const handleSelectAvailableFreight = (freight: FreightType) => {
    const key = getAddressGroupKey(freight)
    const matching = availableFreights.filter(
      (f) => f.id !== freight.id && getAddressGroupKey(f) === key,
    )

    if (matching.length > 0) {
      setSameAddressModal({
        isOpen: true,
        targetFreight: freight,
        matchingFreights: matching,
      })
    } else {
      addFreightsToSelection([freight])
    }
  }

  const handleToggleAllSelected = () => {
    if (orderedFreights.length === 0) return
    setFreightSelected([])
    setOrderedFreights([])
    setWayPoints([])
  }

  const handleToggleAllAvailable = () => {
    const listToSelect =
      filteredAvailableFreights.length > 0
        ? filteredAvailableFreights
        : availableFreights
    if (listToSelect.length === 0) return
    addFreightsToSelection(listToSelect)
  }

  const handleOptimizeRoute = async () => {
    const addressStopGroups = orderedStopGroups.filter(
      (group) => group.address && group.address !== 'Sem endereço',
    )
    const withoutAddressGroups = orderedStopGroups.filter(
      (group) => !group.address || group.address === 'Sem endereço',
    )

    if (addressStopGroups.length <= 1) {
      setFeedback({
        isOpen: true,
        message:
          'Selecione fretes em pelo menos 2 endereços válidos para calcular a melhor rota.',
        statusOk: false,
      })
      return
    }

    if (addressStopGroups.length > 25) {
      setFeedback({
        isOpen: true,
        message:
          'O Google Maps permite no máximo 25 paradas para otimização de rota.',
        statusOk: false,
      })
      return
    }

    const googleMaps = (window as any).google?.maps
    if (!googleMaps) {
      setFeedback({
        isOpen: true,
        message:
          'Serviço de mapas ainda não está pronto. Aguarde um instante.',
        statusOk: false,
      })
      return
    }

    setIsOptimizing(true)
    try {
      const directionsService = new googleMaps.DirectionsService()

      const formattedWaypoints = addressStopGroups.map((group) => ({
        location: `${group.address}, Brasil`,
        stopover: true,
      }))

      const effectiveOrigin = originAddress || formattedWaypoints[0].location
      const effectiveDestination = companyDestination
        ? originAddress ||
          formattedWaypoints[formattedWaypoints.length - 1].location
        : formattedWaypoints[formattedWaypoints.length - 1].location

      const waypointsToOptimize = companyDestination
        ? formattedWaypoints
        : formattedWaypoints.slice(0, -1)

      directionsService.route(
        {
          origin: effectiveOrigin,
          destination: effectiveDestination,
          waypoints: waypointsToOptimize,
          optimizeWaypoints: true,
          travelMode: googleMaps.TravelMode.DRIVING,
        },
        (result: any, status: any) => {
          setIsOptimizing(false)
          if (
            status === googleMaps.DirectionsStatus.OK &&
            result?.routes?.[0]
          ) {
            const waypointOrder: number[] =
              result.routes[0].waypoint_order || []
            if (waypointOrder.length > 0) {
              let optimizedGroups: StopGroup[] = []
              if (companyDestination) {
                optimizedGroups = waypointOrder
                  .map((idx) => addressStopGroups[idx])
                  .filter(Boolean)
              } else {
                const intermediate = waypointOrder
                  .map((idx) => addressStopGroups[idx])
                  .filter(Boolean)
                const lastItem =
                  addressStopGroups[addressStopGroups.length - 1]
                optimizedGroups = [...intermediate, lastItem]
              }

              if (optimizedGroups.length === addressStopGroups.length) {
                const allOptimizedGroups = [
                  ...optimizedGroups,
                  ...withoutAddressGroups,
                ]
                const optimizedFreights = allOptimizedGroups.flatMap(
                  (group) => group.freights,
                )
                setOrderedFreights(optimizedFreights)
                setFreightSelected(optimizedFreights.map((f) => f.id))
                const newWaypoints = optimizedGroups.map((group) => ({
                  location: group.address,
                  stopover: true,
                }))
                setWayPoints(newWaypoints)
                setFeedback({
                  isOpen: true,
                  message: 'Melhor rota calculada e ordenada com sucesso!',
                  statusOk: true,
                })
              }
            }
          } else {
            console.error('Erro ao otimizar rota:', status)
            let errorMsg = 'Não foi possível calcular a melhor rota.'
            if (status === 'MAX_WAYPOINTS_EXCEEDED') {
              errorMsg = 'Limite de paradas excedido para a rota.'
            } else if (
              status === 'ZERO_RESULTS' ||
              status === 'NOT_FOUND'
            ) {
              errorMsg =
                'Um ou mais endereços não foram localizados pelo mapa.'
            }
            setFeedback({
              isOpen: true,
              message: errorMsg,
              statusOk: false,
            })
          }
        },
      )
    } catch (err) {
      setIsOptimizing(false)
      console.error('Erro no cálculo da rota:', err)
      setFeedback({
        isOpen: true,
        message: 'Erro ao calcular a melhor rota.',
        statusOk: false,
      })
    }
  }

  const handleVehicle = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newVehicle = Number(e.target.value)
    if (newVehicle === selectedVehicle) {
      setSelectedVehicle(0)
    } else {
      setSelectedVehicle(newVehicle)
    }
  }

  useEffect(() => {
    const getFreights = async () => {
      const url = `${process.env.REACT_APP_GATEWAY_BASE_URL}/router/freight/route/${0}`
      const response = await axios.get(url)
      setFreights(response.data)
    }

    const getVehicles = async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_GATEWAY_BASE_URL}/equipment/vehicles`,
      )
      setVehicles(response.data)
    }

    getVehicles()
    getFreights()
  }, [])

  useEffect(() => {
    if (router) {
      setFreightSelected(
        router.Freight.map((freight: FreightItem) => freight.id),
      )
      setOrderedFreights(router.Freight)
      setSelectedVehicle(router.Vehicle.id)
      setDate(dataFormatter(router.date))
      if (router.companyDestination !== undefined) {
        setCompanyDestination(router.companyDestination)
      }
      if (router.responsible !== undefined) {
        setresponsible(router.responsible)
      }
      setWayPoints(
        router.Freight
          .filter((freight: FreightItem) => freight.Address?.street)
          .map((freight: FreightItem) => {
            return {
              location: `${freight.Address!.street}, ${freight.Address!.number} - ${freight.Address!.Neighborhood?.City?.name || ''}/${freight.Address!.Neighborhood?.City?.State?.uf || ''}`,
              stopover: true,
            }
          }),
      )
    }
  }, [router?.id])

  const Maps = useMemo(() => {
    const MapsComponent: React.FC = () => {
      const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY
      const defaultCenter = companyCoordinates || {
        lat: -29.6877,
        lng: -51.1331,
      }
      const defaultZoom = 11

      if (!googleMapsApiKey) {
        throw new Error('Google Maps API key is not set')
      }

      return (
        <div style={{ width: '100%', height: '100%' }}>
          <MyMap
            apiKey={googleMapsApiKey}
            center={defaultCenter}
            zoom={defaultZoom}
            wayPoints={waypoints}
            companyDestination={companyDestination}
          />
        </div>
      )
    }

    return <MapsComponent />
  }, [waypoints, companyDestination, companyCoordinates])

  const getRouterTooltipText = (freight: FreightType): string => {
    const addressText = freight.Address?.street
      ? `${freight.Address.street}, ${freight.Address.number} - ${freight.Address.Neighborhood?.City?.name || ''}/${freight.Address.Neighborhood?.City?.State?.uf || ''}`
      : 'Sem endereço cadastrado'
    return `Empresa: ${freight.Company?.companyName || ''}\nEndereço: ${addressText}\nObs: ${freight.observation || 'Não há'}`
  }

  return (
    <>
      {/* <ContainerHeader>
                <BigText>Novo roteiro:</BigText>
                <OptionsDiv>
                    <ButtonOfSection onClick={() => router ? putRouter() : postRouter()}>
                        <ButtonOfSectionText>{router ? 'Atualizar roteiro' : 'Criar roteiro'}</ButtonOfSectionText>
                    </ButtonOfSection>
                </OptionsDiv>
            </ContainerHeader> */}

      <DivComponents style={{ border: '' }}>
        <OptionsDiv className='reverse'>
          <StyledLink
            onClick={() => {
              setRouterSection('routers')
              // setTabIndex(1)
              navigate('/panel/router/routers')
              setRouter(null)
            }}
            className='linkMode'
          >
            Roteiros e fretes
          </StyledLink>
          <StyledLink style={{ marginLeft: '0.3rem' }}>
            {' '}
            {router?.id ? '> Editar roteiro' : '> Novo roteiro'}
          </StyledLink>
        </OptionsDiv>
        <Container>
          <FormContainer>
            <InputDiv>
              <CenterItensContainer>
                <InputLabel>Veículo</InputLabel>
                <ConformityStatus isvalue={!selectedVehicle}>
                  {selectedVehicle ? (
                    <>
                      <Check size={20} />{' '}
                    </>
                  ) : (
                    <>
                      <Info size={18} />{' '}
                    </>
                  )}
                </ConformityStatus>
              </CenterItensContainer>
              <SelectData
                value={selectedVehicle || router?.Vehicle?.id || 0}
                onChange={handleVehicle}
              >
                <StyledOption value={router?.Vehicle?.id || ''}>
                  {router?.Vehicle?.plate || 'Selecione..'}
                </StyledOption>
                {vehicles.map((vehicle) => (
                  <StyledOption key={vehicle.id} value={vehicle.id}>
                    {vehicle.plate}
                  </StyledOption>
                ))}
              </SelectData>
            </InputDiv>

            <InputDiv>
              <CenterItensContainer>
                <InputLabel>Data</InputLabel>
                <ConformityStatus isvalue={date.length < 10}>
                  {!(date.length < 10) ? (
                    <>
                      <Check size={20} />{' '}
                    </>
                  ) : (
                    <>
                      <Info size={18} />{' '}
                    </>
                  )}
                </ConformityStatus>
              </CenterItensContainer>
              <StyledDate
                type='date'
                onChange={handleDateChange}
                value={formatToDateInput(date)}
                max='9999-12-31'
              />
            </InputDiv>

            <InputDiv>
              <InputLabel>Responsável da Rota</InputLabel>
              <Input
                type='text'
                placeholder='Nome do Responsável'
                value={responsible}
                onChange={(e) => setresponsible(e.target.value)}
              />
            </InputDiv>

            <InputDiv>
              <SwitchDiv>
                <InputLabel>Voltar à origem</InputLabel>
                <SwitchBox>
                  <SwitchInput
                    type='checkbox'
                    onChange={() => setCompanyDestination(!companyDestination)}
                    checked={companyDestination}
                  />
                  <SwitchSlider className='slider'></SwitchSlider>
                </SwitchBox>
              </SwitchDiv>
            </InputDiv>

            <InputDiv>
              <div style={{ display: 'flex' }}>
                <InputLabel>Frete</InputLabel>
                <p
                  style={{
                    fontSize: '12px',
                    color: '#0091d4',
                    backgroundColor: '#e5e7eb',
                    padding: '2px 8px ',
                    borderRadius: '12px',
                    fontWeight: 'bold',
                    marginLeft: '0.5rem',
                  }}
                >
                  {routerInfo?.track}
                </p>
              </div>
              <StyledSearch
                placeholder='Buscar cliente ou endereço...'
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </InputDiv>
            <OptionsContainer>
              {orderedFreights.length > 0 && (
                <div style={{ marginBottom: '16px' }}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginBottom: '8px',
                      gap: '8px',
                      flexWrap: 'wrap',
                    }}
                  >
                    <div
                      style={{
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#374151',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        userSelect: 'none',
                      }}
                    >
                      <StyledCheckList
                        className='selected'
                        onClick={handleToggleAllSelected}
                        style={{ cursor: 'pointer', flexShrink: 0 }}
                        title='Desmarcar todos os selecionados'
                      />
                      <span>
                        Fretes Selecionados ({orderedFreights.length})
                      </span>
                    </div>

                    <button
                      type='button'
                      onClick={handleOptimizeRoute}
                      disabled={isOptimizing || orderedStopGroups.length < 2}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '5px',
                        backgroundColor: '#0090D3',
                        color: '#ffffff',
                        border: 'none',
                        borderRadius: '6px',
                        padding: '4px 10px',
                        fontSize: '11px',
                        fontWeight: '600',
                        cursor:
                          isOptimizing || orderedStopGroups.length < 2
                            ? 'not-allowed'
                            : 'pointer',
                        opacity:
                          isOptimizing || orderedStopGroups.length < 2 ? 0.6 : 1,
                        transition: 'all 0.2s ease',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      <Route size={13} />
                      {isOptimizing ? 'Calculando...' : 'Calcular melhor rota'}
                    </button>
                  </div>

                  <DndContext
                    sensors={sensors}
                    collisionDetection={closestCenter}
                    onDragEnd={handleDragEnd}
                    modifiers={[
                      restrictToVerticalAxis,
                      restrictToParentElement,
                    ]}
                  >
                    <SortableContext
                      items={filteredOrderedStopGroups.map((g) => g.id)}
                      strategy={verticalListSortingStrategy}
                    >
                      {filteredOrderedStopGroups.map((group) => {
                        const addressGroups = orderedStopGroups.filter(
                          (g) => g.address && g.address !== 'Sem endereço',
                        )
                        const addressIndex = addressGroups.findIndex(
                          (g) => g.id === group.id,
                        )
                        return (
                          <DraggableStopGroupItem
                            key={group.id}
                            group={group}
                            index={addressIndex >= 0 ? addressIndex : 0}
                            hasCompanyOrigin={
                              companyDestination || !!originAddress
                            }
                            onUnselectFreight={handleUnselectFreight}
                          />
                        )
                      })}
                    </SortableContext>
                  </DndContext>
                </div>
              )}

              {filteredAvailableFreights.length > 0 && (
                <div>
                  <div
                    style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#374151',
                      marginBottom: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      userSelect: 'none',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                      }}
                    >
                      <StyledCheckList
                        className=''
                        onClick={handleToggleAllAvailable}
                        style={{ cursor: 'pointer', flexShrink: 0 }}
                        title='Selecionar todos os disponíveis'
                      />
                      <span>Fretes Disponíveis</span>
                    </div>
                    <span
                      style={{
                        fontSize: '11px',
                        color: '#6b7280',
                        fontWeight: 500,
                      }}
                    >
                      {filteredAvailableFreights.length} disponíveis
                    </span>
                  </div>

                  {availableWithAddress.map((freight: FreightType) => (
                    <RouterTooltip
                      key={`available-tooltip-${freight.id}`}
                      freight={freight}
                    >
                      <StyledFreight
                        key={`available-${freight.id}`}
                        onClick={() => handleSelectAvailableFreight(freight)}
                      >
                        <StyledChecklistContainer>
                          <StyledCheckList
                            className={
                              freightSelected.includes(freight.id)
                                ? 'selected'
                                : ''
                            }
                          />
                        </StyledChecklistContainer>
                        <FreightInfo>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px',
                              flexWrap: 'wrap',
                            }}
                          >
                            <StyledFreightText
                              title={freight.Company?.companyName}
                            >
                              {freight.Company?.companyName
                                ? freight.Company.companyName
                                    .split(/\s|-/)
                                    .slice(0, 2)
                                    .join(' ') + '...'
                                : ''}
                            </StyledFreightText>
                            <TypeBadge type={freight.type} />
                            {freight.status === 'Não Entregue' && (
                              <NotDeliveredTag />
                            )}
                          </div>
                          <div>
                            <StyledFreightSubText>
                              {`${freight.Address?.street || ''}, ${freight.Address?.number || ''} - ${freight.Address?.Neighborhood?.City?.name || ''}/${freight.Address?.Neighborhood?.City?.State?.uf || ''}`}
                            </StyledFreightSubText>
                            {freight.observation && (
                              <StyledFreightObsText
                                title={freight.observation}
                              >
                                Obs: {freight.observation}
                              </StyledFreightObsText>
                            )}
                          </div>
                        </FreightInfo>
                      </StyledFreight>
                    </RouterTooltip>
                  ))}

                  {availableWithoutAddress.length > 0 && (
                    <div style={{ marginTop: '16px' }}>
                      <div
                        style={{
                          paddingTop: '12px',
                          borderTop: '2px dashed #cbd5e1',
                          marginBottom: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          userSelect: 'none',
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            fontSize: '13px',
                            fontWeight: '600',
                            color: '#475569',
                          }}
                        >
                          <MapPinOff size={15} color='#e11d48' />
                          <span>Sem endereço</span>
                          <span
                            style={{
                              fontSize: '11px',
                              fontWeight: 700,
                              backgroundColor: '#fee2e2',
                              color: '#e11d48',
                              padding: '1px 6px',
                              borderRadius: '10px',
                            }}
                          >
                            {availableWithoutAddress.length}
                          </span>
                        </div>
                        <span
                          onClick={() => addFreightsToSelection(availableWithoutAddress)}
                          style={{
                            cursor: 'pointer',
                            fontSize: '11px',
                            fontWeight: 600,
                            color: '#0090D3',
                            userSelect: 'none',
                          }}
                          title='Selecionar todos sem endereço'
                        >
                          Selecionar todos
                        </span>
                      </div>

                      {availableWithoutAddress.map((freight: FreightType) => (
                        <RouterTooltip
                          key={`available-noaddr-tooltip-${freight.id}`}
                          freight={freight}
                        >
                          <StyledFreight
                            key={`available-noaddr-${freight.id}`}
                            onClick={() => handleSelectAvailableFreight(freight)}
                            style={{
                              borderLeft: '4px solid #f43f5e',
                              backgroundColor: '#fff',
                              boxShadow: '0 1px 2px rgba(244, 63, 94, 0.08)',
                            }}
                          >
                            <StyledChecklistContainer>
                              <StyledCheckList
                                className={
                                  freightSelected.includes(freight.id)
                                    ? 'selected'
                                    : ''
                                }
                              />
                            </StyledChecklistContainer>
                            <FreightInfo>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '6px',
                                  flexWrap: 'wrap',
                                }}
                              >
                                <StyledFreightText
                                  title={freight.Company?.companyName}
                                >
                                  {freight.Company?.companyName
                                    ? freight.Company.companyName
                                        .split(/\s|-/)
                                        .slice(0, 2)
                                        .join(' ') + '...'
                                    : ''}
                                </StyledFreightText>
                                <TypeBadge type={freight.type || 'Sem endereço'} />
                                {freight.status === 'Não Entregue' && (
                                  <NotDeliveredTag />
                                )}
                              </div>
                              <div>
                                <StyledFreightSubText
                                  style={{
                                    color: '#e11d48',
                                    fontStyle: 'italic',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    marginTop: '2px',
                                  }}
                                >
                                  <MapPinOff size={11} />
                                  Sem endereço cadastrado
                                </StyledFreightSubText>
                                {freight.observation && (
                                  <StyledFreightObsText
                                    title={freight.observation}
                                  >
                                    Obs: {freight.observation}
                                  </StyledFreightObsText>
                                )}
                              </div>
                            </FreightInfo>
                          </StyledFreight>
                        </RouterTooltip>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </OptionsContainer>
          </FormContainer>
          <div style={{ width: '100%', paddingBottom: '4rem' }}>
            <IframeContainer>{Maps}</IframeContainer>
            <ButtonContainer
              style={{ marginTop: '0.5rem', marginBottom: '0.5rem' }}
            >
              {duplicateBlocker ? (
                <ButtonCreate className='disable'>Aguarde</ButtonCreate>
              ) : (
                <ButtonCreate
                  onClick={() => (router ? putRouter() : postRouter())}
                >
                  <img
                    style={{ width: '1.5rem', height: '1.5rem' }}
                    src={save}
                    alt='save'
                  />
                  Salvar Rota
                </ButtonCreate>
              )}
            </ButtonContainer>
          </div>
        </Container>
      </DivComponents>

      {sameAddressModal.isOpen && sameAddressModal.targetFreight && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            padding: '16px',
          }}
          onClick={() =>
            setSameAddressModal({
              isOpen: false,
              targetFreight: null,
              matchingFreights: [],
            })
          }
        >
          <div
            style={{
              backgroundColor: '#fff',
              borderRadius: '10px',
              maxWidth: '520px',
              width: '100%',
              boxShadow:
                '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
              overflow: 'hidden',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                padding: '16px 20px',
                borderBottom: '1px solid #e5e7eb',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div
                  style={{
                    width: '34px',
                    height: '34px',
                    borderRadius: '8px',
                    backgroundColor: '#e0f2fe',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#0090D3',
                  }}
                >
                  <MapPin size={18} />
                </div>
                <div>
                  <h3
                    style={{
                      margin: 0,
                      fontSize: '15px',
                      fontWeight: 600,
                      color: '#111827',
                    }}
                  >
                    Fretes no mesmo endereço encontrados
                  </h3>
                  <p style={{ margin: 0, fontSize: '12px', color: '#6b7280' }}>
                    Deseja incluir os demais fretes para este destino?
                  </p>
                </div>
              </div>
              <button
                type='button'
                onClick={() =>
                  setSameAddressModal({
                    isOpen: false,
                    targetFreight: null,
                    matchingFreights: [],
                  })
                }
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#9ca3af',
                  cursor: 'pointer',
                  padding: '4px',
                }}
              >
                <X size={18} />
              </button>
            </div>

            <div
              style={{
                padding: '16px 20px',
                maxHeight: '350px',
                overflowY: 'auto',
              }}
            >
              <div
                style={{
                  backgroundColor: '#f8fafc',
                  border: '1px solid #e2e8f0',
                  borderRadius: '6px',
                  padding: '10px 12px',
                  marginBottom: '12px',
                  fontSize: '12px',
                  color: '#334155',
                }}
              >
                <strong>Endereço:</strong>{' '}
                {sameAddressModal.targetFreight.Address
                  ? `${sameAddressModal.targetFreight.Address.street}, ${sameAddressModal.targetFreight.Address.number} - ${sameAddressModal.targetFreight.Address.Neighborhood?.City?.name || ''}/${sameAddressModal.targetFreight.Address.Neighborhood?.City?.State?.uf || ''}`
                  : 'Sem endereço cadastrado'}
              </div>

              <p
                style={{
                  margin: '0 0 8px 0',
                  fontSize: '12px',
                  fontWeight: 600,
                  color: '#374151',
                }}
              >
                Frete selecionado e outros{' '}
                {sameAddressModal.matchingFreights.length} frete(s) disponível(is):
              </p>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {[
                  sameAddressModal.targetFreight,
                  ...sameAddressModal.matchingFreights,
                ].map((f, i) => (
                  <div
                    key={f.id}
                    style={{
                      border: i === 0 ? '1px solid #0090D3' : '1px solid #e5e7eb',
                      backgroundColor: i === 0 ? '#f0f9ff' : '#fff',
                      borderRadius: '6px',
                      padding: '8px 12px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: '8px',
                    }}
                  >
                    <div style={{ minWidth: 0, flex: 1 }}>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '6px',
                          flexWrap: 'wrap',
                        }}
                      >
                        <span
                          style={{
                            fontSize: '13px',
                            fontWeight: 600,
                            color: '#111827',
                          }}
                        >
                          {f.Company?.companyName}
                        </span>
                        <TypeBadge type={f.type} />
                        {i === 0 && (
                          <span
                            style={{
                              fontSize: '10px',
                              fontWeight: 600,
                              backgroundColor: '#0090D3',
                              color: '#fff',
                              borderRadius: '4px',
                              padding: '1px 5px',
                            }}
                          >
                            Clicado
                          </span>
                        )}
                      </div>
                      {f.orderNumber && (
                        <div
                          style={{
                            fontSize: '11px',
                            color: '#4b5563',
                            marginTop: '2px',
                          }}
                        >
                          Venda/Pedido: {f.orderNumber}
                        </div>
                      )}
                      {f.observation && (
                        <div
                          style={{
                            fontSize: '11px',
                            color: '#6b7280',
                            marginTop: '2px',
                          }}
                        >
                          Obs: {f.observation}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div
              style={{
                padding: '12px 20px',
                borderTop: '1px solid #e5e7eb',
                backgroundColor: '#f9fafb',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                gap: '8px',
              }}
            >
              <button
                type='button'
                onClick={() =>
                  setSameAddressModal({
                    isOpen: false,
                    targetFreight: null,
                    matchingFreights: [],
                  })
                }
                style={{
                  padding: '7px 12px',
                  fontSize: '12px',
                  fontWeight: 500,
                  borderRadius: '6px',
                  border: '1px solid #d1d5db',
                  backgroundColor: '#fff',
                  color: '#374151',
                  cursor: 'pointer',
                }}
              >
                Cancelar
              </button>
              <button
                type='button'
                onClick={() => {
                  addFreightsToSelection([sameAddressModal.targetFreight!])
                  setSameAddressModal({
                    isOpen: false,
                    targetFreight: null,
                    matchingFreights: [],
                  })
                }}
                style={{
                  padding: '7px 12px',
                  fontSize: '12px',
                  fontWeight: 600,
                  borderRadius: '6px',
                  border: '1px solid #0090D3',
                  backgroundColor: '#fff',
                  color: '#0090D3',
                  cursor: 'pointer',
                }}
              >
                Selecionar apenas este
              </button>
              <button
                type='button'
                onClick={() => {
                  addFreightsToSelection([
                    sameAddressModal.targetFreight!,
                    ...sameAddressModal.matchingFreights,
                  ])
                  setSameAddressModal({
                    isOpen: false,
                    targetFreight: null,
                    matchingFreights: [],
                  })
                }}
                style={{
                  padding: '7px 14px',
                  fontSize: '12px',
                  fontWeight: 600,
                  borderRadius: '6px',
                  border: 'none',
                  backgroundColor: '#0090D3',
                  color: '#fff',
                  cursor: 'pointer',
                }}
              >
                Selecionar todos ({sameAddressModal.matchingFreights.length + 1})
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default NewRouter
